export type EditorDocument = Record<string, unknown>;

export const isEditorDocument = (value: unknown): value is EditorDocument =>
	typeof value === 'object' && value !== null && !Array.isArray(value);

/**
 * Which settings area is editing the templates. Programme templates are keyed by the programme
 * (`mip-id`), deal templates by the deal (`deal-id`); the two lists never overlap. The two
 * organisation kinds are an organisation's defaults for each of those lists.
 */
export enum EmailTemplateScopeKind {
	PROGRAMME = 'programme',
	DEAL = 'deal',
	ORGANIZATION = 'organization',
	ORGANIZATION_DEAL = 'organizationDeal',
}

/** True for both deal tiers, which share the deal template list and so the same copy. */
export const isDealTemplateScope = (kind: EmailTemplateScopeKind): boolean =>
	kind === EmailTemplateScopeKind.DEAL || kind === EmailTemplateScopeKind.ORGANIZATION_DEAL;

export interface EmailTemplateScope {
	kind: EmailTemplateScopeKind;
	/**
	 * Programme (mip) id for `programme`, deal id for `deal`, organisation id for `organization`
	 * and `organizationDeal`. The first two travel as request headers; only the organisation
	 * routes take it in the path.
	 */
	id: string;
}
